const currencyMixin = {
  filters: {
    BrazilianCurrency(value) {
      if (typeof value == "string") {
        value = value.trim().replaceAll(",", "");
      }

      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(value);
    }
  },

  methods: {
    formatarMoeda(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value || 0);
    }
  }
};

export default currencyMixin;
